/* eslint-disable import/prefer-default-export */
import { RootState } from 'redux/schemas';

export const getOrgProfileField = (
  state: RootState,
  orgProfileFieldId: number,
) => state.models.orgProfileFields[orgProfileFieldId.toString()];

export const getCourseProfileQuestion = (
  state: RootState,
  profileQuestionId: number,
) => state.models.courseProfileQuestions[profileQuestionId.toString()];
